import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperSocialGroupCreateShopPage } from './shopper-social-group-create-shop';

@NgModule({
  declarations: [
    ShopperSocialGroupCreateShopPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperSocialGroupCreateShopPage),
    TranslateModule.forChild()
  ],
})
export class ShopperSocialGroupCreateShopPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-social-group-create-shop/shopper-social-group-create-shop.module.ts